import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

interface AddCardDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (sides: string[]) => void;
  sideNames: string[];
}

const AddCardDialog: React.FC<AddCardDialogProps> = ({
  open,
  onClose,
  onSave,
  sideNames,
}) => {
  const { t } = useTranslation();
  const [sides, setSides] = useState<string[]>(Array(sideNames.length).fill(''));

  const handleSave = () => {
    if (sides.every(side => side.trim())) {
      onSave(sides);
      setSides(Array(sideNames.length).fill(''));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('cards.addCard')}</DialogTitle>
      <DialogContent>
        {sideNames.map((name, index) => (
          <TextField
            key={index}
            fullWidth
            label={name}
            value={sides[index] || ''}
            onChange={(e) => {
              const newSides = [...sides];
              newSides[index] = e.target.value;
              setSides(newSides);
            }}
            sx={{ mt: 2 }}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          onClick={handleSave}
          disabled={!sides.every(side => side.trim())}
          variant="contained"
        >
          {t('cards.addCard')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCardDialog; 